export default __webpack_public_path__ + "static/media/G0003.9fcaab8e.png";